import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.137.297a9.75 9.75 0 0 1 4.195 16.647l-.122.113a9.75 9.75 0 0 1-12.918 0l-.122-.112A9.75 9.75 0 0 1 12.137.297m-4.68 1.53a8.25 8.25 0 0 0-3.875 13.402 7.42 7.42 0 0 1 3.385-2.69 4.5 4.5 0 1 1 5.568 0 7.42 7.42 0 0 1 3.385 2.69A8.25 8.25 0 0 0 7.457 1.827M6.75 9.004a3 3 0 1 1 3 3 3.01 3.01 0 0 1-3-3m3 4.5a6 6 0 0 0-5.053 2.766 8.23 8.23 0 0 0 10.106 0 6 6 0 0 0-5.053-2.766",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }